module.exports = __webpack_public_path__ + "img/ydtop_wuhan.df4c8327.png";